import Index  from '@/views/Relatorios/Index'

const routes = [
    {
        meta: {auth: true},
        path: '/relatorios',
        name: 'relatorios',
        component: Index
    },
]
export default routes
